import MessageMediatorClient from './helpers/mediator/MessageMediatorClient';

class MediatorClient
{
  constructor (settings)
  {
    this.started = false;
    this.client = false;
    this.listeners = new Set();
  }

  start (sessionData, callback) {
    // console.log('sessionData', sessionData);
    if (this.started) return callback ? callback() : false;
    this.client = new MessageMediatorClient({
      // host: 'https:// childconnect.production.mediator.cairsolutions.com', //  mandatory. Mediator server address
      name: sessionData.user.name, //  mandatory
      user_id: sessionData.user.user_id, //  mandatory, must be unique
      agency_id: sessionData.user.agency_id, //  mandatory, must be unique
      swagger: sessionData.swagger || false
    });

    this.client.on('mediator:start', (eventObj) => {
      // console.log(this.client.store);
      // console.log(eventObj);
      this.started = true;
      if (callback) callback();
    }); //  client.destroyEvent( startEvent );

    //  start Mediator client and connect to socket session
    this.client.start();
  }

  registerEvent (eventName, callback) {
    if (!this.hasListener(eventName)) {
      this.listeners.add(eventName); // Track the event name
      this.client.on(eventName, callback); // Register the event directly on the client
    }
  }

  hasListener (eventName) {
    return this.listeners.has(eventName); // Check if the event is already tracked
  }

}

let Mediator = new MediatorClient();

export default Mediator;



// WEBPACK FOOTER //
// ./src/Mediator.js